// --------------------------------------------------------------
// Created On: 2025-04-24
// Author: Zachary Thomas
//
// Last Modified: 2025-05-30
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// Given a group of series, figure out if they should all have borders or not.
// Borders should only appear if there are multiple series on the graph that do not share the same y-axis.
export default function getShouldYAxesHaveBorders(
  series: AccumulationDataSeries[] | TimeDataSeries[],
  axisMode: AxisMode
): boolean {
  if (series.length === 1) {
    return false;
  }

  if (axisMode === "Y_AXIS_UOM") {
    let previousUnitName: string | null = null;
    for (const singleSeries of series) {
      if (previousUnitName === null || previousUnitName === singleSeries.unitName) {
        previousUnitName = singleSeries.unitName;
      } else {
        return true; // Found multiple unit names.
      }
    }
  }

  return true;
}

interface TimeDataSeries {
  name: string;
  unitName: string;
  unitShortName: string;
  data: [number, number][];
}

interface AccumulationDataSeries {
  name: string;
  unitName: string;
  unitShortName: string;
  data: number[];
}

type AxisMode = "Y_AXIS_ATTRIBUTE" | "Y_AXIS_UOM";
